import { Box, Chip, Skeleton, Stack, styled } from "@mui/material";
import React, { useEffect } from "react";
import { PositionResultText } from "../Typography/title";
import { Authoritytext, SkillLeveltext } from "../Typography/paragraph";
import useFetch from "../../../Service/Hooks/useFetch";
import { ApiUrls } from "../../Utils/globalVariables";

export default function SearchPositionResult({ code }) {

    const [{response, isLoading, error}, doFetch] = useFetch(ApiUrls.GetANZSCOBaseData, "get", true)

    useEffect(() => {
        if(code) {
            doFetch({id: code})
        }
    }, [code])

    const ExtraResultBox = styled(Stack)(
        ({ theme }) => `
            border: 1px solid red;
            width: 100%;
            box-shadow: 2px 1px 6px 0px #e3e3e3;
            border: 1px solid #e1e1e1;
            padding: 10px;
        `
    )

    const LevelChip = styled(Chip)(
        ({ theme }) => `
            background: ${theme.palette.teritiary.main};
            border-radius: 4px !important;
            color: white;
            font-weight: bold;
            font-family: inherit;
        `
    )

    const AuthorityChip = styled(Chip)(
        ({ theme }) => `
            background: white;
            border-radius: 2px !important;
            color: black;
            font-weight: normal;
            border: 1px solid black;
            font-family: inherit;
            font-size: ${theme.typography.caption.fontSize};
        `
    )

    if(code && isLoading) {
        return (
            <Stack spacing={3} justifyContent="center" sx={{width: "100%", direction: "ltr"}}>
                <Stack spacing={3} justifyContent="center">
                    <PositionResultText variant="h2">
                        {response.anzsco}: {response.persian_name}
                    </PositionResultText>
                    <PositionResultText variant="h2" sx={{mt: "1.5rem !important"}} >
                        {response.name} : {response.anzsco}
                    </PositionResultText>
                </Stack>
                <ExtraResultBox direction="row" justifyContent="center" spacing={2}>
                    <SkillLeveltext>
                         <LevelChip label={response.skill} size="small" /> : سطح مهارت
                    </SkillLeveltext>
                    <Authoritytext>
                         <AuthorityChip label={response.assesing_authority} size="small" /> : مرجع ارزیابی 
                    </Authoritytext>
                </ExtraResultBox>
            </Stack>
        )
    } else if(!isLoading && code) {
        return (
            <Skeleton sx={{width: "100%", height: "80px", my: 3}} variant="rounded" />
        )
    }   

}